export default
    [// 个人中心/后台管理--子类路由
        {
            path: "/user",
            redirect: "timetable"
        },
        {
            path: "timetable",
            component: () => import("@/views/user/timetable")
        },
        {
            path: "experience",
            component: () => import("@/views/user/appointment")
        },
        {
            path: "timeagreement",
            component: () => import("@/views/user/timeagreement")
        },
        {
            path: "teacheragreement",
            component: () => import("@/views/user/teacheragreement")
        },
    ]



// WEBPACK FOOTER //
// ./src/router/children/chil_user.js